import { UserProvider } from "contexts/User";
import "./di/register";
import Routing from "./Routing";
import { AuthProvider } from "contexts/Auth";
import I18n from "components/materials/I18n";
import { HeaderProvider } from "contexts/Header";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { ToastProvider } from "contexts/Toast";
import { container } from "tsyringe";
import ApplicationConfig from "configs/ApplicationConfig";

function App() {
	const applicationConfig = container.resolve(ApplicationConfig);
	const config = applicationConfig.get();

	return (
		<GoogleOAuthProvider clientId="370726047308-2vsrc9tv2doilfrnhqh6atcm98l6ansc.apps.googleusercontent.com">
			<GoogleReCaptchaProvider reCaptchaKey={config.recaptcha.siteKey}>
				<AuthProvider>
					<UserProvider>
						<HeaderProvider>
							<I18n>
								<ToastProvider>
									<Routing />
								</ToastProvider>
							</I18n>
						</HeaderProvider>
					</UserProvider>
				</AuthProvider>
			</GoogleReCaptchaProvider>
		</GoogleOAuthProvider>
	);
}

export default App;
